import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true
    }
  ]
})
export class SliderComponent implements OnInit, ControlValueAccessor {

  static readonly internal_step = 100;
  static presonText: string;

  // https://github.com/angular/material2/pull/10243

  @Input()
  min: number;

  @Input()
  max: number;

  @Input()
  disabled = false;

  private _value: number;

  get inner_min(): number {
    return this.min * SliderComponent.internal_step;
  }

  get inner_max(): number {
    return this.max * SliderComponent.internal_step;
  }

  get inner_value(): number {
    return this._value * SliderComponent.internal_step;
  }

  set inner_value(value: number) {
    this._value = Math.round(value / SliderComponent.internal_step);
    this.onChange(this.value);
  }

  get value(): number {
    if (!this._value) {
      return this.min;
    }
    return this._value;
  }

  set value(value: number) {
    this._value = value;
  }

  private onChange = (value: number) => { };

  constructor(
    private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    this.translateService.get('Persons').subscribe((res: string) => {
      SliderComponent.presonText = res;
    });
  }

  writeValue(value: number): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  formatLabel(value: number | null) {
    let personCount = 0;
    if (!value) {
      personCount = this.min ? Math.round(this.min / SliderComponent.internal_step) : 0;
    } else {
      if (value && this.min && value === Math.round(this.min / SliderComponent.internal_step)) {
        personCount = Math.round(this.min / SliderComponent.internal_step);
      } else {
        personCount = Math.round(value / SliderComponent.internal_step);
      }
    }

    return personCount + ' ' + SliderComponent.presonText;
  }
}
